module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('title.' + _vm.action + '-external-service')))]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 40
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('data-form', {
    attrs: {
      "model": "external-services",
      "entity": _vm.externalService,
      "fields": _vm.fields,
      "beforeSubmit": _vm.mapBeforeSubmit,
      "after-submit": _vm.afterSubmit
    },
    on: {
      "change": _vm.onChange
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-93169612!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/external-service/ExternalServiceDetails.vue
// module id = 1175
// module chunks = 2